import { DeliveryModel } from '@audibene/ta.utils-opportunity'

type SupportedDeliveryModel = Extract<DeliveryModel, 'TA_LIGHT' | 'TELEAUDIOLOGY'>

const supportedDeliveryModels = new Set<SupportedDeliveryModel>([
  'TA_LIGHT',
  'TELEAUDIOLOGY',
]) as Set<SupportedDeliveryModel> & {
  has: (deliveryModel: DeliveryModel) => boolean
}

export { supportedDeliveryModels }
